import { useContext } from "react";
import { Box, Flex, Link, Spacer, IconButton, Button, Menu, MenuButton, MenuList, MenuItem, Badge } from "@chakra-ui/react";
import { FiLogOut } from "react-icons/fi";
import { ChevronDownIcon } from "@chakra-ui/icons";
import AuthContext from "../contexts/AuthContext";
import axios from "axios";


const Navbar = () => {
  const { logout } = useContext(AuthContext);

  const downloadReport = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get('/api/tax_report', {
        responseType: 'blob', // Important to handle binary data
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'financial_report.pdf'); // or any other extension
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the report:", error);
    }
  };

  return (
    <Box as="nav" bg="teal.500" color="white" px={4} py={2} position="sticky" top={0} zIndex={1000}>
      <Flex alignItems="center">
        <Link href="/dashboard" fontSize="lg" fontWeight="bold" mr={4}>
          Dashboard
        </Link>
        <Link href="/stock-analysis" fontSize="lg" fontWeight="bold" mr={4}>
          Stock Analysis
        </Link>
        <Menu>
          <MenuButton as={Button} rightIcon={<ChevronDownIcon />} fontWeight="bold"
            mr={4}
            bg="teal.500"
            _hover={{ bg: "teal.700" }}
            position="relative"
            color="white"
          >
            Trading212
            <Badge
              colorScheme="pink"
              position="absolute"
              bottom={1}
              right={1}
              fontSize="0.7em"
              borderRadius="full"
              px={2}
            >
              new
            </Badge>
          </MenuButton>
          <MenuList bg="teal.500" borderColor="teal.600">
            <MenuItem as="a" href="/trading212" bg="teal.500" _hover={{ bg: "teal.700" }} fontWeight="bold">
              Portafoglio
            </MenuItem>
            <MenuItem as="a" href="/trading212/instruments" bg="teal.500" _hover={{ bg: "teal.700" }} fontWeight="bold">
              Strumenti disponibili
            </MenuItem>
          </MenuList>
        </Menu>
        <Spacer />
        <Button
          onClick={downloadReport}
          variant="ghost"
          colorScheme="whiteAlpha"
          _hover={{ bg: "teal.600" }}
          mr={4}
        >
          Download Report
        </Button>
        <IconButton
          aria-label="Logout"
          icon={<FiLogOut />}
          onClick={logout}
          variant="ghost"
          colorScheme="whiteAlpha"
          _hover={{ bg: "teal.600" }}
        />
      </Flex>
    </Box>
  );
};

export default Navbar;